import { render, staticRenderFns } from "./NotesListRow.vue?vue&type=template&id=71e27b6d&scoped=true&"
import script from "./NotesListRow.vue?vue&type=script&lang=js&"
export * from "./NotesListRow.vue?vue&type=script&lang=js&"
import style0 from "./NotesListRow.vue?vue&type=style&index=0&id=71e27b6d&lang=scss&scoped=true&"
import style1 from "./NotesListRow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e27b6d",
  null
  
)

export default component.exports